import { Fixture } from '../models/fixture';
import { TableEntry } from '../models/leagueStats';
import { Team } from '../models/team';

export function calculateTable(teams: Team[], fixtures: Fixture[]): TableEntry[] {
  const table: TableEntry[] = [];
  const teamStats: { [key: string]: TableEntry } = {};

  teams.forEach(team => {
    teamStats[team.name] = { name: team.name, image: team.image, liveLink: team.liveLink, P: 0, W: 0, D: 0, L: 0, GD: 0, GF: 0, GA: 0, PTS: 0 };
  });

  fixtures.forEach(fixture => {
    if (!fixture.isPlayed) return;

    const { home, away, homeScore, awayScore } = fixture;
    teamStats[home].P += 1;
    teamStats[home].GD += homeScore - awayScore;
    teamStats[home].GF += homeScore;
    teamStats[home].GA += awayScore;
    teamStats[away].P += 1;
    teamStats[away].GD += awayScore - homeScore;
    teamStats[away].GF += awayScore;
    teamStats[away].GA += homeScore;

    if (homeScore > awayScore) {
      teamStats[home].W += 1;
      teamStats[away].L += 1;
    } else if (homeScore < awayScore) {
      teamStats[home].L += 1;
      teamStats[away].W += 1;
    } else {
      teamStats[home].D += 1;
      teamStats[away].D += 1;
    }
  });

  Object.values(teamStats).forEach(team => {
    team.PTS = team.W * 3 + team.D;
    table.push(team);
  });

  return table.sort((a, b) => b.PTS - a.PTS || b.GD - a.GD || b.GF - a.GF);
}
